import { render, staticRenderFns } from "./BillingPlans.vue?vue&type=template&id=10e950c2&"
import script from "./BillingPlans.vue?vue&type=script&lang=js&"
export * from "./BillingPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports